<div [bentoBusyLoader]="!loadMfe" class="banking-staff-dashboard-loader ng-bento" >
	<mfe-loader module-name="@onviobr/banking-staff-dashboard" class="ng-bento"></mfe-loader>
</div>